/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Fix_CreateInputs */

const en_fix_create = /** @type {(inputs: Fix_CreateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Add "${i?.name}" as a new ingredient`)
};

const de_fix_create = /** @type {(inputs: Fix_CreateInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`„${i?.name}“ als neue Zutat anlegen`)
};

/**
* | output |
* | --- |
* | "Add \"{name}\" as a new ingredient" |
*
* @param {Fix_CreateInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const fix_create = /** @type {((inputs: Fix_CreateInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fix_CreateInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_fix_create(inputs)
	return en_fix_create(inputs)
});